
import { useEffect, useRef, useState } from "react";
import type SliderType from "react-slick";
import SliderOrig from "react-slick";
import { CloseOutlined, ConsoleSqlOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";
import { mixGetV1 } from "services/mixin";

import './styles.scss'
import { useTranslation } from "react-i18next";

const Slider = SliderOrig as unknown as React.ComponentType<any>;

const ProductContent = ({ data, typeC }: any) => {
	const sliderRef = useRef<SliderType | null>(null);
	const [currentIndex, setCurrentIndex] = useState<number>(-1)
	const [detailData, setDetailData] = useState<any>()
	const [name, setName] = useState<string>('')
	const [email, setEmail] = useState<string>('')
	const [birtday, setBirthday] = useState<string>('')
	const [phone, setPhone] = useState<string>('')
	const [tag, setTag] = useState<string>('overview')
	const { t } = useTranslation();
	const [langSetting, setLangSetting] = useState<string>('')

	useEffect(() => {
		const data = localStorage.getItem('i18nextLng')

		if (data) setLangSetting(data)
	}, [])

	function formatDate(dateStr: string): string {
		const date = new Date(dateStr);

		const day = String(date.getDate()).padStart(2, "0");
		const month = String(date.getMonth() + 1).padStart(2, "0"); // tháng bắt đầu từ 0
		const year = date.getFullYear();

		return `${day}/${month}/${year}`;
	}

	const handleShow = (index: number, dataSelect: any) => {
		if (dataSelect) {
			const test = localStorage.getItem('user')
			if (test) {
				const test1 = JSON.parse(test)
				const handleDate = test1.birthday ? formatDate(test1.birthday) : ''
				setName(test1.last_name ? test1.last_name : '')
				setBirthday(handleDate)
				setPhone(test1.phone ? test1.phone : '')
				setEmail(test1.email ? test1.email : '')
				setDetailData(JSON.parse(dataSelect))
				console.log('data', data)
			}
		}
		setCurrentIndex(index)
	}

	const settingSlider = {
		slidesToShow: 4,
		slidesToScroll: 4,
		dots: false,
		arrows: true,
		fade: false,
		adaptiveHeight: true,
		infinite: false,
		speed: 400,
		swipe: true,
		draggable: true,
		slideClass: "custom",
		cssEase: "cubic-bezier(0.77, 0, 0.18, 1)",
		responsive: [
			{
				breakpoint: 1400,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				}
			},
			// {
			// 	breakpoint: 376,
			// 	settings: {
			// 		slidesToShow: 1,
			// 		slidesToScroll: 1,
			// 	}
			// },
		]
		// beforeChange: (current: number, next: number) => {
		// 	console.log("beforeChange → next:", next);
		// 	sliderRef.current?.slickGoTo(next);
		// 	setCurrentIndex(next)
		// },
	}

	function replaceTemplate(str: any, data: Record<string, string | number>) {
		if (typeof str !== "string") {
			return "" // nếu null/undefined/không phải string thì trả rỗng
		}

		try {
			return str.replace(/{{(.*?)}}/g, (_, key) => {
				return data[key.trim()] !== undefined ? String(data[key.trim()]) : `{{${key}}}`
			})
		} catch (e) {
			console.error("replaceTemplate error:", e)
			return str
		}
	}
	const [obProductDisplay, setObProductDisplay] = useState({} as any)
	const getOrder = async () => {
		const user = localStorage.getItem('user')
		const res = await mixGetV1(`/api/v1/be/orders?locale=en&user_id=${user ? JSON.parse(user).id : ''}`)
		if (res.status) {
			const temp = {} as any
			res.data.items.map((val: any) => {
				if (val.product_display) {
					temp[val.product_display.id] = val.product_display
				}
			})
			setObProductDisplay(temp)
		}
	}

	useEffect(() => {
		getOrder()
	}, [])

	return (
		<div className="product-content">
			<div className="main-slider">
				{data.length > 0 && <Slider {...settingSlider} className="force-left">
					{data.map((item: any) => (
						<div key={item.id}>
							<div
								onClick={() => handleShow(item.id, item.introduction)}
								className={`slider-container ${currentIndex === item.id ? 'selected' : ''} ${currentIndex !== -1 ? 'height-154' : ''}`}
								style={{
									backgroundImage: `url(${langSetting === 'vi' ? JSON.parse(item.image).vi : JSON.parse(item.image).en})`,
								}}
							>
								<div className={`bg-content ${currentIndex === item.id ? 'selected' : ''}`}>
									<div className="content">
										<span className="title">{langSetting === 'vi' ? JSON.parse(item.title).vi : JSON.parse(item.title).en}</span>
										<span className="sub-title">{langSetting === 'vi' ? JSON.parse(item.subtitle).vi : JSON.parse(item.subtitle).en}</span>
										<div className="btn-arrow">
											<img src="./images/icon_arrow.png" alt="icon" />
										</div>
									</div>
								</div>
							</div>
						</div>
					))}
				</Slider>}
				{data.length === 0 && typeC === 1 && <p>{t('NoProductChoice')}</p>}
				{data.length === 0 && typeC === 2 && <p>{t('provideDateOfBirth')}</p>}
				{/* <TestSlider data={data} handleShow={handleShow} currentIndex={currentIndex} /> */}
			</div>
			<div className="main-container">
				<div className={`header-content flex justify-between px-3 product-header  py-2  ${currentIndex === -1 ? 'hidden' : ''}`}>
					<div className="flex flex-row justify-start items-center px-3 py-2 gap-4">
						<div className={`cursor-pointer border-yellow-500 text-[var(--primary-color)] ${tag === 'overview' ? 'active' : ''}`} onClick={() => setTag('overview')
						}> {t('Overview')} </div>
						<div className={`cursor-pointer border-yellow-500 text-[var(--primary-color)] ${tag === 'detail' ? 'active' : ''}`} onClick={() => setTag('detail')
						}> {t('Detail')} </div>
					</div>
					<div className="items-center  px-3 py-2" onClick={() => setCurrentIndex(-1)}>
						<CloseOutlined
							className="icon-close"
							onClick={() => setCurrentIndex(-1)}
						/>
					</div>
				</div>
				{data.map((item: any) => (
					<div
						key={item.id}
						className={`main-content ${currentIndex === item.id ? 'selected' : ''}`}
					>
						{tag === 'overview' && (
							<div
								className="bg-main py-3"
								style={{ backgroundImage: `url(${item.banner_image_url})` }}
							>
								<div className="content py-10 px-8">
									<h1 className="titlev1 !text-[18px]">{langSetting === 'vi' ? JSON.parse(item.title).vi : JSON.parse(item.title).en}</h1>
									{detailData?.map((item2: any, index: number) => {
										const replacedDescription = replaceTemplate(item2.description, { name, birtday, email, phone })

										return (
											<div key={index} >
												<div className="!text-[14px]" dangerouslySetInnerHTML={{ __html: replacedDescription }} />
											</div>
										)
									})}
									<button className="!py-2 !px-4 !text-[12px] rounded-lg">
										<a target="_blank" download href={obProductDisplay[item.id]?.pdf_url || obProductDisplay[item.id]?.pdf_file || '#'}>{t('Downloadfile')}</a>
									</button>
								</div>

								<div className="wrap-img">
									<img src={`${langSetting === 'vi' ? JSON.parse(item.image).vi : JSON.parse(item.image).en}`} loading="lazy" alt="avatar" />
								</div>
							</div>
						)}

						{tag === 'detail' && (
							<div
								className="bg-main py-3"
								style={{ backgroundImage: `url(${item.banner_image_url})` }}
							>
								<div className="content py-10 px-8">
									<h1 className="titlev1 !text-[18px] mb-4">Chi tiết báo cáo</h1>

									<div className="spec-table mb-6 border border-[#e6ebf1] rounded-lg overflow-hidden">
										<div className="spec-row flex justify-between p-3 border-b border-[#e6ebf1] text-[13px]">
											<span className="k text-[#5b6b7c]">Định dạng</span>
											<span className="v text-[#0b1c2e] font-bold">PDF tương tác</span>
										</div>
										<div className="spec-row flex justify-between p-3 border-b border-[#e6ebf1] text-[13px]">
											<span className="k text-[#5b6b7c]">Số trang</span>
											<span className="v text-[#0b1c2e] font-bold">24 trang</span>
										</div>
										<div className="spec-row flex justify-between p-3 border-b border-[#e6ebf1] text-[13px]">
											<span className="k text-[#5b6b7c]">Ngôn ngữ</span>
											<span className="v text-[#0b1c2e] font-bold">Việt / Anh</span>
										</div>
										<div className="spec-row flex justify-between p-3 border-b border-[#e6ebf1] text-[13px]">
											<span className="k text-[#5b6b7c]">Cập nhật</span>
											<span className="v text-[#0b1c2e] font-bold">06/2026</span>
										</div>
										<div className="spec-row flex justify-between p-3 border-b border-[#e6ebf1] text-[13px]">
											<span className="k text-[#5b6b7c]">Thời hạn truy cập</span>
											<span className="v text-[#0b1c2e] font-bold">Trọn đời</span>
										</div>
										<div className="spec-row flex justify-between p-3 border-b border-[#e6ebf1] text-[13px]">
											<span className="k text-[#5b6b7c]">Tác giả</span>
											<span className="v text-[#0b1c2e] font-bold">Đội ngũ LUMIR Research</span>
										</div>
									</div>

									{detailData?.map((item2: any, index: number) => {
										const replacedDescription = replaceTemplate(item2.description, { name, birtday, email, phone })
										return (
											<div key={index} className="mb-6">
												<div className="!text-[14px] text-[#33465c] leading-relaxed" dangerouslySetInnerHTML={{ __html: replacedDescription }} />
											</div>
										)
									})}
									{/* 
									<div className="purchase-row flex items-center gap-4 flex-wrap pt-4 border-t border-[#e6ebf1] mt-4">
										<button className="!py-3 !px-6 !text-[14px] font-bold rounded-xl bg-gradient-to-r from-[#e8b93a] to-[#c9a227] text-[#241800] shadow-md flex items-center gap-2 border-none cursor-pointer">
											<a target="_blank" download href={obProductDisplay[item.id]?.pdf_url || obProductDisplay[item.id]?.pdf_file || '#'} className="!text-[#241800]">{t('Downloadfile')}</a>
										</button>
									</div> */}
								</div>

								<div className="wrap-img">
									<img src={`${langSetting === 'vi' ? JSON.parse(item.image).vi : JSON.parse(item.image).en}`} loading="lazy" alt="avatar" />
								</div>
							</div>
						)}
					</div>
				))}
			</div>
		</div>
	)
}
export default ProductContent;